// SriLanka.jsx
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

// === HERO BACKGROUND ===
import sriLankaHeroBg from '../assets/pick/19.jpg';
import introImage from '../assets/pick/sri-lanka-map-with-city-names-free-vector.jpg';

// === PLACE IMAGES ===
import place1 from '../assets/Sri Lanka/800px-Sigiriya_(141688197).jpeg';
import place17 from '../assets/Sri Lanka/Sigiriya-Uncovered-Delving-into-the-History-Art-and-Legends-800x609-1.jpg';
import place18 from '../assets/Sri Lanka/01.jpg';
import place19 from '../assets/Sri Lanka/Sigriya_rock_from_directly_above_1600x.webp';

import place2 from '../assets/Sri Lanka/Kandy-toothrelictemple-dawn.jpg';
import place20 from '../assets/Sri Lanka/temple-sacred-tooth-relic-kandy-sri-lanka.jpg';
import place21 from '../assets/Sri Lanka/Temple-Sacred-Tooth-Relic-kandy-sri-lanka (1).jpg';
import place22 from '../assets/Sri Lanka/Kandy-and-The-Temple.jpg';

import place3 from '../assets/Sri Lanka/Nine Arch Bridge Sri Lanka.jpg';
import place23 from '../assets/Sri Lanka/little-adams-peak-ella-1440x960.jpg';
import place24 from '../assets/Sri Lanka/POST_PORTRAIT_0002_IMG_9077.webp';
import place25 from '../assets/Sri Lanka/52773560Ravana_Falls.jpg';

import place4 from '../assets/Sri Lanka/Yala-National-Park-1.jpg';
import place26 from '../assets/Sri Lanka/hq720.jpg';
import place27 from '../assets/Sri Lanka/image_872e72884c.jpg';
import place28 from '../assets/Sri Lanka/yala-safari-srilanka-economy-tours.jpg.webp';

import place5 from '../assets/Sri Lanka/Galle-Fort.webp';
import place29 from '../assets/Sri Lanka/galle_147f8ef7-7d19-4c30-9069-eb59128e1c2c.webp';
import place30 from '../assets/Sri Lanka/Galle-Fort-Walking-Tour-555x655-1.jpg';
import place31 from '../assets/Sri Lanka/shutterstock-409990654_main_1490260387805.jpeg';

import place6 from '../assets/Sri Lanka/nuwara-eliya-in-sri-lanka.jpg';
import place32 from '../assets/Sri Lanka/historical-background-in-nuwara-eliya.jpg';
import place33 from '../assets/Sri Lanka/grand-hotel-nuwara-eliya.jpg';
import place34 from '../assets/Sri Lanka/nuwara-eliya-gregory.jpg';

import place7 from '../assets/Sri Lanka/Climb-Adams-Peak-Sri-Pada.webp';
import place35 from '../assets/Sri Lanka/Adams-Peak-Sri-Lanka.webp';
import place36 from '../assets/Sri Lanka/mini-adams-peak-1-7.jpg';
import place37 from '../assets/Sri Lanka/adams-peak-season.jpg';

import place8 from '../assets/Sri Lanka/800x750-94.jpg';
import place38 from '../assets/Sri Lanka/Michael-at-Worlds-End-View-Horton-Plains-National-Park.jpg';
import place39 from '../assets/Sri Lanka/horton-plains-national.jpg';
import place40 from '../assets/Sri Lanka/Horton-Plains-Nature-Reserve-800x600-1.webp';

import place9 from '../assets/Sri Lanka/Bentota-Sri-Lanka-Everything-You-Need-To-Know.jpg';
import place41 from '../assets/Sri Lanka/Ventura-Beach-Sri-Lanka-Bentota-Beach-2023-2024.jpg';
import place42 from '../assets/Sri Lanka/bentota.jpg';
import place43 from '../assets/Sri Lanka/01 (1).jpg';

import place10 from '../assets/Sri Lanka/images.jpeg';
import place44 from '../assets/Sri Lanka/1332748-jaffna-library.jpg';
import place45 from '../assets/Sri Lanka/Jaffna-Fort-Jaffna-Sri-Lanka.jpg.webp';
import place46 from '../assets/Sri Lanka/Nainatheevu-in-Jaffna-768x1024.jpeg';

import place11 from '../assets/Sri Lanka/800x750-1.jpg';
import place47 from '../assets/Sri Lanka/shutterstock-480723793_main_1481633955837.jpeg';
import place48 from '../assets/Sri Lanka/Avukana-Buddha-Statue-Anuradhapua-Ancinet-City.webp';
import place49 from '../assets/Sri Lanka/Anuradhapura-788x537.webp';

import place12 from '../assets/Sri Lanka/Polonnaruwa-Lankathilaka-Feature-Image.jpg';
import place50 from '../assets/Sri Lanka/UNESCO-World-Heritage-Site-Brahmanic-Monuments-Polonnaruwa-Sri-Lanka-1.jpg';
import place51 from '../assets/Sri Lanka/ThePolonnaruwaVatadage-857341721661428.jpg';
import place52 from '../assets/Sri Lanka/polonnaruwa-640x360.jpg';

import place13 from '../assets/Sri Lanka/Unawatuna-Beach-1.jpg';
import place53 from '../assets/Sri Lanka/Unawatuna-Beach-Sri-Lanka.webp';
import place54 from '../assets/Sri Lanka/20190926_080608-1024x768.webp';
import place55 from '../assets/Sri Lanka/jungle-beach-unawatuna-00-1024x768.webp';

import place14 from '../assets/Sri Lanka/37.jpg';
import place56 from '../assets/Sri Lanka/Colombo-city.jpg';
import place57 from '../assets/Sri Lanka/colombo-main-header.jpg';
import place58 from '../assets/Sri Lanka/ee.jpg';

import place15 from '../assets/Sri Lanka/udawalawe-national-park.jpg';
import place59 from '../assets/Sri Lanka/Udawalawe-National-Park-2.jpeg';
import place60 from '../assets/Sri Lanka/12f5bb1d6b11d9f5a5a9b1f64c59bd41-uda-walawe-national-park.jpg';
import place61 from '../assets/Sri Lanka/156-1024x683.jpg';

import place16 from '../assets/Sri Lanka/01 (2).jpg';
import place62 from '../assets/Sri Lanka/800x750-9.jpg';
import place63 from '../assets/Sri Lanka/dambulla-cave-temple-architecture-1024x585.jpg';
import place64 from '../assets/Sri Lanka/555x465px-Dambulla_cave_temple_37.webp';

// === FAMOUS THINGS IMAGES ===
import ceylonTea from '../assets/Sri Lanka/30917a4b2dee144385c49297465d68a3_XL-768x340.jpg';
import spices from '../assets/Sri Lanka/Spices_1200px_23_11_16-1000x600.jpg';
import gems from '../assets/pick/46.jpg';
import ayurveda from '../assets/Sri Lanka/Ayurveda-Background-gallery-pop-up-(1)-min.jpg';
import handicrafts from '../assets/Sri Lanka/Local-handicraft-workshops-and-shopping-in-Galle.jpg';
import elephants from '../assets/Sri Lanka/Asian-elephant-Elephas-Maximus.webp';
import food from '../assets/Sri Lanka/1689750105634.jpeg';
import festivals from '../assets/Sri Lanka/Three-tuskers-clad-in-illuminated-red-costumes-standing-in-front-of-the-illuminated-white-building-complex-1.jpg';
import coconut from '../assets/Sri Lanka/processed-coconut-products.webp';
import sarees from '../assets/Sri Lanka/E015.webp';
import dances from '../assets/Sri Lanka/DSC_2290-1038x576.jpg';
import stiltFishing from '../assets/Sri Lanka/S4.jpg';
import moonstones from '../assets/Sri Lanka/moonstone-3.jpg';
import cricket from '../assets/Sri Lanka/image_f8c21aee4f.jpg';
import herbs from '../assets/Sri Lanka/Ayurveda-making.jpg';
import masks from '../assets/Sri Lanka/Sri-lankan-Masks.jpg';

// === MOTION VARIANTS ===
const sectionVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const SriLanka = () => {
    const { t } = useTranslation();
    const [selectedPlace, setSelectedPlace] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);

    const openModal = (place) => setSelectedPlace(place);
    const closeModal = () => setSelectedPlace(null);
    const openImagePreview = (image) => setSelectedImage(image);
    const closeImagePreview = () => setSelectedImage(null);

    // === DATA ARRAYS (Tradotto con t()) ===
    const places = [
        { images: [place1, place17, place18, place19] },
        { images: [place2, place20, place21, place22] },
        { images: [place3, place23, place24, place25] },
        { images: [place4, place26, place27, place28] },
        { images: [place5, place29, place30, place31] },
        { images: [place6, place32, place33, place34] },
        { images: [place7, place35, place36, place37] },
        { images: [place8, place38, place39, place40] },
        { images: [place9, place41, place42, place43] },
        { images: [place10, place44, place45, place46] },
        { images: [place11, place47, place48, place49] },
        { images: [place12, place50, place51, place52] },
        { images: [place13, place53, place54, place55] },
        { images: [place14, place56, place57, place58] },
        { images: [place15, place59, place60, place61] },
        { images: [place16, place62, place63, place64] },
    ];

    const famousThings = [
        { image: ceylonTea },
        { image: spices },
        { image: gems },
        { image: ayurveda },
        { image: handicrafts },
        { image: elephants },
        { image: food },
        { image: festivals },
        { image: coconut },
        { image: sarees },
        { image: dances },
        { image: stiltFishing },
        { image: moonstones },
        { image: cricket },
        { image: herbs },
        { image: masks },
    ];

    return (
        <div className="bg-black">
            {/* ===== HERO SECTION ===== */}
            <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={sectionVariants}
                className="relative flex h-[60vh] w-full items-center justify-center font-lato md:h-[50vh] lg:h-[80vh]"
            >
                <img
                    src={sriLankaHeroBg}
                    alt={t('sriLanka.heroAlt')}
                    className="absolute inset-0 h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-[#020202c7] to-[#42424259]" />

                <div className="container relative z-10 flex items-center justify-center pt-[100px]">
                    <div className="w-full">
                        <h1 className="text-center text-[50px] font-semibold leading-[80px] text-white font-copperplate md:text-[60px] lg:text-[80px]">
                            {t('sriLanka.heroTitle')}
                        </h1>
                        <div className="flex justify-center text-center leading-8">
                            <p className="mt-6 max-w-[90%] font-lato text-[16px] font-semibold tracking-[5%] text-[#96BA33] sm:mt-10 sm:max-w-2xl sm:text-[25px]">
                                {t('sriLanka.heroSubtitle')}
                            </p>
                        </div>

                        <div className="absolute left-[30px] top-10">
                            <svg width="289" height="245" viewBox="0 0 289 245" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M289 1H1V244.5" stroke="white" />
                            </svg>
                        </div>
                        <div className="absolute -bottom-10 right-[30px]">
                            <svg width="289" height="244" viewBox="0 0 289 244" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 243.5H288V0" stroke="white" />
                            </svg>
                        </div>
                    </div>
                </div>
            </motion.div>

            {/* ===== INTRO SECTION ===== */}
            <motion.section
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={sectionVariants}
                className="bg-black py-20"
            >
                <div className="container mx-auto px-4">
                    <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
                        <div className="w-full lg:w-1/2">
                            <img
                                src={introImage}
                                alt={t('sriLanka.introImageAlt')}
                                className="w-full h-auto object-cover rounded-2xl shadow-2xl"
                                loading="lazy"
                            />
                        </div>

                        <div className="w-full lg:w-1/2 space-y-6 text-white">
                            {t('sriLanka.intro', { returnObjects: true }).map((paragraph, i) => (
                                <p key={i} className="text-sm md:text-base lg:text-lg leading-relaxed font-inknut">
                                    {paragraph}
                                </p>
                            ))}
                        </div>
                    </div>
                </div>
            </motion.section>

            {/* ===== ATTRACTIVE PLACES SECTION ===== */}

            <div className="container mx-auto px-4">
                <h2
                    className="text-center text-4xl md:text-5xl lg:text-6xl font-bold font-konkhmer mb-10"
                    style={{
                        background: "linear-gradient(to right, #009CE6, #96BA33)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                    }}
                >
                    {t('sriLanka.placesTitle')}
                </h2>

                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 place-items-center">
                    {places.map((place, index) => {
                        const placeKey = `sriLanka.places.list.${index}`;
                        return (
                            <motion.div
                                key={index}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.98 }}
                                className="group relative w-full max-w-[300px] cursor-pointer overflow-hidden rounded-lg shadow-xl transition-all duration-300 hover:shadow-2xl flex flex-col"
                                onClick={() => openModal({
                                    images: place.images,
                                    name: t(`${placeKey}.name`),
                                    description: t(`${placeKey}.desc`)
                                })}
                            >
                                <div className="relative flex-1">
                                    <img
                                        src={place.images[0]}
                                        alt={t(`${placeKey}.name`)}
                                        className="h-64 w-full object-cover transition-transform duration-500 group-hover:scale-110"
                                        loading="lazy"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center p-4">
                                    </div>
                                </div>
                                <div className="bg-black p-4 text-center flex flex-col items-center">
                                    <h3 className="text-white font-konkhmer text-lg font-bold mb-3">
                                        {t(`${placeKey}.name`)}
                                    </h3>
                                    <button className="bg-[#009CE6] text-white px-6 py-2 rounded-lg font-bold text-sm hover:bg-[#96BA33] transition-colors">
                                        {t('sriLanka.viewMore')}
                                    </button>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>


            {/* ===== FAMOUS THINGS SECTION ===== */}

            <div className="container mx-auto px-4">
                <h2
                    className="text-center text-4xl md:text-5xl lg:text-6xl font-bold font-konkhmer mb-16"
                    style={{
                        background: "linear-gradient(to right, #009CE6, #96BA33)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                    }}
                >
                    {t('sriLanka.famousTitle')}
                </h2>

                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 place-items-center">
                    {famousThings.map((item, index) => {
                        const thingKey = `sriLanka.famous.list.${index}`;
                        return (
                            <motion.div
                                key={index}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.98 }}
                                className="group relative w-full max-w-[300px] overflow-hidden rounded-lg shadow-xl transition-all duration-300 hover:shadow-2xl flex flex-col"
                            >
                                <div className="relative flex-1">
                                    <img
                                        src={item.image}
                                        alt={t(`${thingKey}.title`)}
                                        className="h-64 w-full object-cover transition-transform duration-500 group-hover:scale-110"
                                        loading="lazy"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center p-4">
                                        <div className="text-center">
                                            <h3 className="text-white font-bold text-lg mb-2">{t(`${thingKey}.title`)}</h3>
                                            <p className="text-white text-sm line-clamp-4">{t(`${thingKey}.desc`)}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-black p-4 text-center">
                                    <h3 className="text-white font-konkhmer text-lg font-bold">{t(`${thingKey}.title`)}</h3>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>


            {/* ===== MODAL: PLACE DETAILS ===== */}
            {selectedPlace && (
                <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4">
                    <motion.div
                        initial={{ scale: 0.9, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        className="bg-white rounded-2xl shadow-2xl p-6 md:p-10 max-w-5xl w-full max-h-[90vh] overflow-y-auto"
                    >
                        <button
                            onClick={closeModal}
                            className="absolute top-4 right-4 bg-gray-200 text-black rounded-full p-2 hover:bg-gray-300 transition"
                            aria-label={t('sriLanka.closeModal')}
                        >
                            X
                        </button>
                        <h2
                            className="text-2xl md:text-3xl font-bold text-center mb-6"
                            style={{
                                background: "linear-gradient(to right, #009CE6, #96BA33)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                backgroundClip: "text",
                            }}
                        >
                            {selectedPlace.name}
                        </h2>
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
                            {selectedPlace.images.map((img, i) => (
                                <img
                                    key={i}
                                    src={img}
                                    alt={`${selectedPlace.name} ${i + 1}`}
                                    className="w-full h-40 md:h-56 object-cover rounded-lg cursor-pointer hover:opacity-90 transition"
                                    onClick={() => openImagePreview(img)}
                                    loading="lazy"
                                />
                            ))}
                        </div>
                        <p className="text-gray-700 text-sm md:text-base leading-relaxed">{selectedPlace.description}</p>
                    </motion.div>
                </div>
            )}

            {/* ===== MODAL: FULL IMAGE PREVIEW ===== */}
            {selectedImage && (
                <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4">
                    <div className="relative">
                        <img
                            src={selectedImage}
                            alt={t('sriLanka.fullImageAlt')}
                            className="max-w-full max-h-full object-contain rounded-lg"
                        />
                        <button
                            onClick={closeImagePreview}
                            className="absolute top-4 right-4 bg-white text-black rounded-full p-2 hover:bg-gray-200 transition"
                            aria-label={t('sriLanka.closeModal')}
                        >
                            X
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SriLanka;